<template>
  <div>
    <!-- HEADER -->
    <CCard class="shadow-sm mb-3">
      <CCardBody>
        <CRow>
          <CCol class="d-flex col-9 col-md-10 col-sm-10">
            <img
              src="/img/icon/store.png"
              style="width: 32px; height: 32px; margin-right: 8px;"
            />
            <select class="custom-select" v-model="shopObjectId" disabled>
              <option selected>{{ $t('selectshop') }}</option>
              <option
                v-for="shop in shops"
                :key="shop.objectId"
                :value="shop.objectId"
              >
                {{ shop.shopName }} - {{ shop.branchName }}
              </option>
            </select>
          </CCol>
          <CCol sm="3" md="2" col="3">
            <router-link :to="`/report/productpackage`">
              <CButton block color="light" class="align-items-center">
                <span>
                  <i
                    class="fi fi-rr-arrow-left mr-2"
                    style="position: relative; top: 2px;"
                  ></i>
                </span>
                {{ $t('back') }}
              </CButton>
            </router-link>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <div v-if="isOrderBuffetEnabled" >
      <CCard>
        <CCardBody>
          <CRow class="mb-3">
            <CCol>
              <h3 class="mb-1">
                {{ $t('packeagereport.packageTitle')}}: {{ packageName || '-' }}
              </h3>
              <p class="text-muted mb-0 small">
                {{ $t('packeagereport.packageDesc', { start: startDate, end: endDate }) }}
              </p>
            </CCol>
          </CRow>

          <CRow class="mb-3 align-items-stretch d-flex">
            <!-- SUMMARY -->
            <CCol md="6" sm="12" class="d-flex">
              <CCard class="shadow-sm h-100 w-100 d-flex flex-column">
                <CCardBody class="d-flex flex-column h-100">

                  <!-- TOP SUMMARY -->
                  <div class="flex-grow-0 mb-3">
                    <div class="d-flex justify-content-between">
                      <div>
                        <div class="text-uppercase text-muted small">
                           {{ $t('packeagereport.totalSales')}}
                        </div>
                        <div class="h3 mb-0 font-weight-semibold">
                          {{ formatMoney(summary.grandTotal) }} 
                        </div>
                      </div>
                      <span class="badge badge-light text-muted align-self-start">
                        {{ $t('packeagereport.includeExtra')}}
                      </span>
                    </div>
                  </div>

                  <!-- PACKAGE TOTAL + EXTRA TOTAL -->
                  <div class="flex-grow-0">
                    <CRow>
                      <CCol lg="6">
                        <div class="card text-center"
                            style="box-shadow:#4dbd74 0 0 0 1px;color:#4dbd74;">
                          <div class="card-body py-2">
                            <div class="text-muted text-uppercase font-weight-bold small">
                               {{ $t('packeagereport.buffetTotal')}}
                            </div>
                            <div class="h3 mb-0">
                              {{ formatMoney(summary.buffetTotal) }} 
                            </div>
                          </div>
                        </div>
                      </CCol>

                      <CCol lg="6">
                        <div class="card text-center"
                            style="box-shadow:#f9b115 0 0 0 1px;color:#f9b115;">
                          <div class="card-body py-2">
                            <div class="text-muted text-uppercase font-weight-bold small">
                              {{ $t('packeagereport.extraTotal')}}
                            </div>
                            <div class="h3 mb-0">
                              {{ formatMoney(summary.extraTotal) }} 
                            </div>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </div>

                  <!-- BILL & CUSTOMER (BOTTOM) -->
                  <div class="mt-auto ">
                    <CRow>
                      <CCol>
                        <CCard class="text-center"
                              style="box-shadow:#20c997 0 0 0 1px;color:#20c997;">
                          <CCardBody class="py-2">
                            <div class="text-muted text-uppercase font-weight-bold small">
                               {{ $t('packeagereport.billCount')}}
                            </div>
                            <div class="h3 mb-0 font-weight-semibold">
                              {{ summary.totalBills || 0 }}
                            </div>
                            <div v-if="summary.totalBills" class="small mt-1 text-muted">
                             {{ $t('packeagereport.avgPerBill', { amount: formatMoney(summary.grandTotal / summary.totalBills) }) }}
                            </div>
                          </CCardBody>
                        </CCard>
                      </CCol>

                      <CCol>
                        <CCard class="text-center"
                              style="box-shadow:#17a2b8 0 0 0 1px;color:#17a2b8;">
                          <CCardBody class="py-2">
                            <div class="text-muted text-uppercase font-weight-bold small">
                              {{ $t('packeagereport.customerCount')}}
                            </div>
                            <div class="h3 mb-0 font-weight-semibold">
                              {{ summary.totalCustomers || 0 }}
                            </div>
                            <div v-if="summary.totalCustomers" class="small mt-1 text-muted">
                              {{ $t('packeagereport.avgPerCustomer', { amount: formatMoney(summary.grandTotal / summary.totalCustomers) }) }}
                            </div>
                          </CCardBody>
                        </CCard>
                      </CCol>
                    </CRow>
                  </div>

                </CCardBody>
              </CCard>
            </CCol>

            <!-- PRICE STATS -->
            <CCol md="6" sm="12" class="d-flex">
              <CCard class="shadow-sm h-100 w-100 flex-column">
                <CCardBody class="h-100 flex-column">
                  <h5 class="mb-1">{{ $t('packeagereport.priceReport') }}</h5>
                  <p class="text-muted small mb-3">
                    {{ $t('packeagereport.priceReportDesc') }}
                  </p>

                  <div class="table-responsive mt-auto">
                    <DataTable
                      class="price-stats-table"
                      :items="priceStatsItems"
                      :fields="priceStatsFields"
                      small striped hover
                      style="white-space: nowrap"
                    >
                      <template #empty>
                        <div class="text-center text-muted py-2">
                          {{ $t('packeagereport.noPriceData') }}
                        </div>
                      </template>
                    </DataTable>
                  </div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>


          <!-- TOP 10 MENUS -->
          <CRow class="mb-3">
            <!-- TOP 10 เมนูในแพ็กเกจ -->
            <CCol lg="6" class="mb-3 mb-lg-0">
              <CCard class="shadow-sm h-100">
                <CCardBody class="m-3">
                  <h5 class="mb-3">{{ $t('packeagereport.topBuffet') }}</h5>
                  <CRow>
                    <!-- list -->
                    <CCol lg="5" class="top-list">
                      <CCallout
                        v-for="(row, index) in topBuffetItems"
                        :key="row.key"
                        class="top-list-item"
                        :style="{
                          borderRadius: '5px',
                          margin: '0.5rem 0',
                          borderLeft: '10px solid ' + getBuffetChartColor(index),
                          boxShadow: '0 0.125rem 0.125rem rgba(0, 0, 21, 0.075)',
                          padding: '5px',
                          backgroundColor: getBuffetBackgroundColor(index)
                        }"
                      >
                        <div
                          class="row m-1 text-muted text-uppercase font-weight-bold"
                        >
                          <div class="text-center text-dark mr-2">
                            {{ index + 1 }}.
                          </div>
                          <div class="col text-left">
                            <strong class="text-dark">
                              {{ row.pluName }}
                            </strong>
                            <div
                              class="m-0 row justify-content-between small"
                            >
                              <p class="m-0">
                                {{ $t('packeagereport.category') }} : {{ row.categoryName }}
                              </p>
                              <p class="m-0">
                                QTY : {{ row.totalQty }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </CCallout>

                      <div
                        v-if="!topBuffetItems.length"
                        class="text-center text-muted py-3"
                      >
                        {{ $t('packeagereport.noBuffetMenu') }}
                      </div>
                    </CCol>

                    <!-- donut -->
                    <CCol lg="7" class="d-flex align-items-center">
                      <CChartDoughnut
                          v-if="buffetTopChart.datasets[0].data.length"
                          :datasets="buffetTopChart.datasets"
                          :labels="buffetTopChart.labels"
                          :options="buffetTopChart.chartOptions"
                          style="height:250px; width:100%;"
                        />
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>

            <!-- TOP 10 เมนูจ่ายเพิ่ม -->
            <CCol lg="6">
              <CCard class="shadow-sm h-100">
                <CCardBody class="m-3">
                  <h5 class="mb-3">{{ $t('packeagereport.topExtra') }}</h5>
                  <CRow>
                    <!-- donut -->
                    <CCol lg="7" class="d-flex align-items-center order-lg-1">
                      <CChartDoughnut
                        v-if="extraTopChart.datasets[0].data.length"
                        :datasets="extraTopChart.datasets"
                        :labels="extraTopChart.labels"
                        :options="extraTopChart.chartOptions"
                        style="height:250px; width:100%;"
                      />
                    </CCol>

                    <!-- list -->
                    <CCol lg="5" class="top-list order-lg-0">
                      <CCallout
                        v-for="(row, index) in topExtraItems"
                        :key="row.key"
                        class="top-list-item"
                        :style="{
                          borderRadius: '5px',
                          margin: '0.5rem 0',
                          borderLeft: '10px solid ' + getExtraChartColor(index),
                          boxShadow: '0 0.125rem 0.125rem rgba(0, 0, 21, 0.075)',
                          padding: '5px',
                          backgroundColor: getExtraBackgroundColor(index)
                        }"
                      >
                        <div
                          class="row m-1 text-muted text-uppercase font-weight-bold"
                        >
                          <div class="text-center text-dark mr-2">
                            {{ index + 1 }}.
                          </div>
                          <div class="col text-left">
                            <strong class="text-dark">
                              {{ row.pluName }}
                            </strong>
                            <div
                              class="m-0 row justify-content-between small"
                            >
                              <p class="m-0">
                                {{ $t('packeagereport.category') }} : {{ row.categoryName }}
                              </p>
                              <p class="m-0">
                                QTY : {{ row.totalQty }}
                              </p>
                              <p class="m-0">
                                Sales : {{ formatMoney(row.totalAmount) }} ฿
                              </p>
                            </div>
                          </div>
                        </div>
                      </CCallout>

                      <div
                        v-if="!topExtraItems.length"
                        class="text-center text-muted py-3"
                      >
                        {{ $t('packeagereport.noExtraMenu') }}
                      </div>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>

          <!-- HISTORY TABLE -->
          <CCard class="shadow-sm">
            <CCardHeader>
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0 font-weight-normal">
                  {{ $t('packeagereport.allBills') }}
                </h5>
                <small class="text-muted">
                  {{ historyItems.length }} {{ $t('packeagereport.billUnit') }}
                </small>
              </div>
            </CCardHeader>
            <CCardBody>
              <DataTable
                :items="historyItems"
                :fields="historyFields"
                hover
                striped
                small
                clickable-rows
                style="white-space: nowrap"
                @row-clicked="toggleHistoryDetails"
              >
                <template #details="{ item }">
                  <CCollapse :show="historyDetails.includes(item.id)">
                    <CCardBody>
                      <h6 class="font-weight-normal mb-1">
                        {{ $t('packeagereport.receipt') }}:
                        <span class="text-success">
                          {{ item.receiptNumber }}
                        </span>
                      </h6>
                      <p class="text-muted mb-2">
                        {{ item.tableName }} •
                        {{ item.numCust }} คน • ยอดรวม
                        {{ item.grandTotalText }} ฿
                      </p>

                      <!-- buffet items -->
                      <h6 class="font-weight-normal mt-3 mb-2">
                        {{ $t('packeagereport.buffetItems')}}
                      </h6>
                      <div class="table-responsive mb-3">
                        <table class="table table-sm table-striped mb-0">
                          <thead class="table-light">
                            <tr>
                              <th>{{$t('productName')}}</th>
                              <th>{{$t('packeagereport.category')}}</th>
                              <th class="text-end">{{$t('packeagereport.quantity')}}</th>
                              <th>{{$t('unit')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="row in item.buffetItems"
                              :key="row.id"
                              class="text-dark font-weight-normal"
                            >
                              <td>{{ row.pluName }}</td>
                              <td>{{ row.categoryName }}</td>
                              <td class="text-end">
                                {{ row.quantity }}
                              </td>
                              <td>{{ row.unit }}</td>
                            </tr>
                            <tr v-if="!item.buffetItems.length">
                              <td colspan="4" class="text-center text-muted py-2">
                                {{$t('packeagereport.noExtraItems')}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- extra items -->
                      <h6 class="font-weight-normal mt-3 mb-2">
                        {{$t('packeagereport.extraItems')}}
                      </h6>
                      <div class="table-responsive mb-3">
                        <table class="table table-sm table-striped mb-0">
                          <thead class="table-light text-dark font-weight-normal">
                            <tr>
                              <th>{{$t('productName')}}</th>
                              <th>{{$t('packeagereport.category')}}</th>
                              <th class="text-end">{{$t('packeagereport.quantity')}}</th>
                              <th>{{$t('unit')}}</th>
                              <th class="text-end">{{$t('price')}}</th>
                              <th class="text-end">{{$t('total')}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="row in item.extraItems"
                              :key="row.id"
                              class="text-dark font-weight-normal"
                            >
                              <td>{{ row.pluName }}</td>
                              <td>{{ row.categoryName }}</td>
                              <td class="text-end">
                                {{ row.quantity }}
                              </td>
                              <td>{{ row.unit }}</td>
                              <td class="text-end">
                                {{ formatMoney(row.price) }}
                              </td>
                              <td class="text-end">
                                {{ formatMoney(row.totalAmount) }}
                              </td>
                            </tr>
                            <tr v-if="!item.extraItems.length">
                              <td colspan="6" class="text-center text-muted py-2">
                                {{$t('packeagereport.noExtraItems')}}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="item.extraItems.length" class="table-light">
                            <tr>
                              <th colspan="4" class="text-end">
                                {{$t('packeagereport.summaryExtra')}}
                              </th>
                              <th></th>
                              <th class="text-end">
                                {{ formatMoney(item.extraTotal || 0) }}
                              </th>
                              <!-- <th class="text-end">
                                {{formatMoney(item.extraProfitTotal || 0)}}
                              </th> -->
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </CCardBody>
                  </CCollapse>
                </template>
              </DataTable>
              <pagination :meta_data="meta_data" v-on:next="fetchOrdersByPackage"> </pagination>
            </CCardBody>
          </CCard>
        </CCardBody>
      </CCard>
    </div>
     <div v-else class="text-center">
      <CCard>
        <CCardBody>
          <img src="/img/BF-banner.jpg" alt="Feature Not Available" style="    width: -webkit-fill-available; " />
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { CChartDoughnut } from '@coreui/vue-chartjs'
import DataTable from '@/containers/DataTable'
import axios from '@/services/service'
import Pagination from '@/containers/Pagination'
import pos from "@/services/local";
import util from "@/util/util";

export default {
  name: 'PackageReportDetail',
  components: {
    CChartDoughnut,
    DataTable,
    Pagination
  },
  data () {
    return {
      packageId: this.$route.query.packageId || null,
      packageName: this.$route.query.packageName || '',
      historyRaw: [],
      historyDetails: [],
      summary: {
        totalBills: 0,
        totalCustomers: 0,
        buffetTotal: 0,
        extraTotal: 0,
        grandTotal: 0
      },
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null
      },
      isLoadingHistory: false,
      loadingDetailId: null,
      priceStats: [],
      buffetMostOrders: [],
      extraMostOrders: [],
      isOrderBuffetEnabled : false
    }
  },
  watch: {
    date: {
      deep: true,
      immediate: false,
      handler() {
        this.reloadAllData()
      }
    }
  },
  async created () {
    await this.fetchPackageSummary()
    await this.fetchPackagePriceStats()
    await this.fetchMostOrderByPackage(true)
    await this.fetchMostOrderByPackage(false)
    await this.fetchOrdersByPackage()
    await this.getOrderShopSetting()
  },
  computed: {
    ...mapGetters(['shops', 'date', 'users', 'isOwner']),

    priceStatsFields () {
      return [
          {
            key: 'pluName',
            label: this.$t('packageReport.priceStats.packageType'),
            _classes: 'text-left text-dark font-weight-normal'
          },
          {
            key: 'priceText',
            label: this.$t('packageReport.priceStats.pricePerHead'),
            _classes: 'text-right text-dark font-weight-normal'
          },
          {
            key: 'quantity',
            label: this.$t('packageReport.priceStats.customerQty'),
            _classes: 'text-right text-dark font-weight-normal'
          },
          {
            key: 'netAmountText',
            label: this.$t('packageReport.priceStats.netSales'),
            _classes: 'text-right text-dark font-weight-normal'
          }
        ]
    },

    priceStatsItems () {
      return this.priceStats.map(r => ({
        ...r,
        priceText: this.formatMoney(r.price || 0),
        quantity: r.quantity || 0,
        netAmountText: this.formatMoney(r.netAmount || 0)
      }))
    },

    uid () {
      return `${localStorage.getItem('shopsUid')}`
    },

    dateDetail () {
      return moment(String(this.$route.params.date)).format('DD MMMM YYYY')
    },

    startDate () {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },

    endDate () {
      return moment(String(this.date.end)).format('DD MMMM YYYY')
    },

    shopObjectId: {
      get () {
        return this.$store.getters.shopObjectId
      },
      set (newValue) {
        return this.$store.dispatch('setShop', newValue)
      }
    },

    filteredBills () {
      if (!this.packageName) return []
      return this.historyRaw.filter(b => b.packageName === this.packageName)
    },

    historyFields () {
      return [
        {
          key: 'dateTimeText',
          label: this.$t('packageReport.history.date'),
          _classes: 'text-left text-dark font-weight-normal'
        },
        {
          key: 'receiptNumber',
          label: this.$t('packageReport.history.receiptNo'),
          _classes: 'text-left text-dark font-weight-normal'
        },
        {
          key: 'tableName',
          label: this.$t('packageReport.history.table'),
          _classes: 'text-left text-dark font-weight-normal'
        },
        {
          key: 'numCust',
          label: this.$t('packageReport.history.customerQty'),
          _classes: 'text-right text-dark font-weight-normal'
        },
        {
          key: 'buffetTotalText',
          label: this.$t('packageReport.history.packageTotal'),
          _classes: 'text-right text-dark font-weight-normal'
        },
        {
          key: 'extraTotalText',
          label: this.$t('packageReport.history.extraTotal'),
          _classes: 'text-right text-dark font-weight-normal'
        },
        {
          key: 'grandTotalText',
          label: this.$t('packageReport.history.grandTotal'),
          _classes: 'text-right text-dark font-weight-normal'
        }
      ]
    },

    historyItems () {
      return this.historyRaw.map(r => {
        const buffetItems = Array.isArray(r.buffetItems) ? r.buffetItems : []
        const extraItems = Array.isArray(r.extraItems) ? r.extraItems : []

        const grandTotal = Number(r.grandTotal ?? r.netAmount ?? 0)
        const extraTotal = Number(r.extraTotal || 0)
        const buffetTotal = grandTotal - extraTotal
        const created = r.payReceiptAt || r.created_at || r.serverTimestamp

        return {
          ...r,
          buffetItems,
          extraItems,
          dateTimeText: this.formatDateTime(created),
          buffetTotalText: this.formatMoney(buffetTotal),
          extraTotalText: this.formatMoney(extraTotal),
          grandTotalText: this.formatMoney(grandTotal),
          extraCostTotal: r.extraCostTotal || 0,
          extraProfitTotal: r.extraProfitTotal || 0
        }
      })
    },

    // TOP buffet menus
    topBuffetItems () {
      return this.buffetMostOrders || []
    },

    buffetTopChart () {
      const items = this.topBuffetItems
      const labels = items.length ? items.map(i => i.pluName) : ['ไม่มีข้อมูล']
      const data = items.length ? items.map(i => i.totalQty) : [1]
      const count = items.length

      return {
        labels,
        datasets: [
          {
            backgroundColor: count
              ? [
                  '#6dbc68',
                  '#cfd06c',
                  '#f7cd72',
                  '#d5b57d',
                  '#ffc6a2',
                  '#a4a663',
                  '#6c9656',
                  '#248456',
                  '#00705e',
                  '#005b47'
                ]
              : ['#ebedef'],
            data
          }
        ],
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
          display: false,
          // position: "right"
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: tooltipItem => {
                  if (!count) return 'ไม่มีข้อมูล'
                  const value = tooltipItem.raw || 0
                  return `${tooltipItem.label}: ${value}`
                }
              }
            }
          }
        }
      }
    },

    // TOP extra menus
    topExtraItems () {
      return this.extraMostOrders || []
    },

    extraTopChart () {
  const items = this.topExtraItems
  const labels = items.length ? items.map(i => i.pluName) : ['ไม่มีข้อมูล']
  const data = items.length ? items.map(i => i.totalAmount) : [1]
  const count = items.length

  return {
    labels,
    datasets: [
      {
        backgroundColor: count
          ? [
              '#55cad7',
              '#8ae2d2',
              '#8debc6',
              '#9bf1b3',
              '#b4f69d',
              '#dfe889',
              '#a8d275',
              '#6dbc68',
              '#0fa562',
              '#00a6ad'
            ]
          : ['#ebedef'],
        data
      }
    ],
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,   
      legend: { 
      display: false,
      // position: "right"
      },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled : false,
          callbacks: {
            label: tooltipItem => {
              if (!count) return 'ไม่มีข้อมูล'
              const value = tooltipItem.raw || 0
              return `${tooltipItem.label}: ${value.toLocaleString('th-TH')} ฿`
            }
          }
        }
      }
    }
  }
},
    chartBaseOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        plugins: {
          legend: { display: true },
          tooltip: {
            callbacks: {
              label(context) {
                const val = context.raw ?? 0
                return `${context.label}: ${val.toLocaleString('th-TH')}`
              }
            }
          }
        }
      }
    }
  },

  methods: {
    // 10 สีพาสเทล (หรือเปลี่ยนได้)
    PALETTE_BUFFET: [
      '#6dbc68', '#8dd17a', '#b3e596', '#d6f4b0',
      '#a4c96c', '#7cac50', '#5c8f36', '#3e7220',
      '#2c5e10', '#1f4a05'
    ],

    PALETTE_EXTRA: [
      '#55cad7', '#7ddde3', '#9ce9e9', '#b9f3ee',
      '#8dd8c4', '#6bbca7', '#4aa08a', '#2c8470',
      '#176a59', '#0a5142'
    ],

    // คืนค่า index ของ key
    getIndexByKey(key, type) {
      const list = type === 'buffet' ? this.topBuffetItems : this.topExtraItems
      return list.findIndex(i => i.key === key)
    },

    // คืนค่าสีพาสเทลตาม key
    getColorByKey(key, type = 'buffet') {
      const list = type === 'buffet'
        ? this.topBuffetItems
        : this.topExtraItems

      const palette = type === 'buffet'
        ? this.PALETTE_BUFFET
        : this.PALETTE_EXTRA

      const idx = list.findIndex(i => i.key === key)
      return idx === -1
        ? '#dfe3e6'
        : palette[idx % palette.length]
    },
    async reloadAllData() {
      await this.fetchPackageSummary()
      await this.fetchPackagePriceStats()
      await this.fetchMostOrderByPackage(true)
      await this.fetchMostOrderByPackage(false)
      await this.fetchOrdersByPackage()
    },
    async fetchOrdersByPackage (page = 1) {
      try {
        this.isLoadingHistory = true

        const params = {
          page: page,
          limit: this.meta_data.limit ,
          shopObjectId: this.shopObjectId,
          packageObjectId: this.packageId,
          startAt: moment(this.date.start).format('YYYY-MM-DD'),
          endAt: moment(this.date.end).format('YYYY-MM-DD')
        }

        const res = await axios.get(
          '/api/v3.0/package/ordersbypackage/data',
          { params }
        )

        const rows = Array.isArray(res.data.data) ? res.data.data : []

        this.historyRaw = rows.map(r => {
          const grandTotal = Number(r.grandTotal ?? r.netAmount ?? 0)

          return {
            ...r,
            receiptNumber: r.receiptNumber || r.orderNo || '-',
            tableName: r.tableName || '-',
            numCust: r.numCust || r.numberOfCustomer || 0,
            grandTotal,
            buffetTotal: 0,
            extraTotal: 0,
            buffetItems: [],
            extraItems: [],
            extraCostTotal: 0,
            extraProfitTotal: 0
          }
        })
        if (res.data.paginate.items == undefined) {
            this.meta_data.items = 0;
        } else {
            this.meta_data.items = res.data.paginate.items;
        }
        this.meta_data.last_page = res.data.paginate.pageCount;
        this.meta_data.current_page = res.data.paginate.currentPage;
        this.meta_data.itemCount = res.data.paginate.itemCount;
        this.meta_data.limit = res.data.paginate.perPage;
      } catch (err) {
        console.error('fetchOrdersByPackage error', err)
        this.historyRaw = []
      } finally {
        this.isLoadingHistory = false
      }
    },

    async fetchOrderItemsByReceipt (row) {
      try {
        this.loadingDetailId = row.id

        const params = {
          page: 1,
          limit: 200,
          receiptObjectId: row.objectId
        }

        const res = await axios.get(
          '/api/v3.0/package/orderitems/data',
          { params }
        )

        const items = Array.isArray(res.data.data) ? res.data.data : []

        const buffetItems = []
        const extraItems = []
        let extraTotal = 0
        let extraCostTotal = 0

        items.forEach(it => {
          const qty = Number(it.quantity) || 0
          const price = Number(it.price) || 0
          const totalAmount = Number(it.totalAmount ?? it.netAmount ?? (price * qty))
          const totalCost = Number(it.totalCost ?? it.stdCost ?? 0)

          const isBuffet =
            it.inSET === true ||
            it.skuType === 'P' ||
            it.categoryName === 'Set'

          if (isBuffet) {
            buffetItems.push({
              id: it.id,
              pluName: it.pluName,
              categoryName: it.categoryName || '-',
              quantity: qty,
              unit: it.unit || ''
            })
          } else {
            extraItems.push({
              id: it.id,
              pluName: it.pluName,
              categoryName: it.categoryName || '-',
              quantity: qty,
              unit: it.unit || '',
              price,
              totalAmount
            })
            extraTotal += totalAmount
            extraCostTotal += totalCost
          }
        })

        const extraProfitTotal = extraTotal - extraCostTotal

        const idx = this.historyRaw.findIndex(h => h.id === row.id)
        if (idx !== -1) {
          this.$set(this.historyRaw, idx, {
            ...this.historyRaw[idx],
            buffetItems,
            extraItems,
            extraTotal,
            extraCostTotal,
            extraProfitTotal
          })
        }
      } catch (err) {
        console.error('fetchOrderItemsByReceipt error', err)
      } finally {
        this.loadingDetailId = null
      }
    },

    async fetchPackageSummary () {
      try {
        const params = {
          shopObjectId: this.shopObjectId,
          startAt: moment(this.date.start).format('YYYY-MM-DD'),
          endAt: moment(this.date.end).format('YYYY-MM-DD'),
          packageObjectId: this.packageId
        }

        const res = await axios.get('/api/v3.0/package/bill/statistics', {
          params
        })

        const row = Array.isArray(res.data.data)
          ? res.data.data[0]
          : res.data.data

        if (row) {
          this.summary = {
            totalBills: row.bill || 0,
            totalCustomers: row.customer || 0,
            buffetTotal: row.packageAmount || 0,
            extraTotal: row.extraAmount || 0,
            grandTotal: row.grandTotal || 0
          }
        }
      } catch (err) {
        console.error('fetchPackageSummary error', err)
      }
    },

    async fetchPackagePriceStats () {
      try {
        const params = {
          shopObjectId: this.shopObjectId,
          startAt: moment(this.date.start).format('YYYY-MM-DD'),
          endAt: moment(this.date.end).format('YYYY-MM-DD'),
          packageObjectId: this.packageId
        }

        const res = await axios.get('/api/v3.0/package/plu/statistics', {
          params
        })

        this.priceStats = Array.isArray(res.data.data)
          ? res.data.data
          : []
      } catch (err) {
        console.error('fetchPackagePriceStats error', err)
        this.priceStats = []
      }
    },

    async fetchMostOrderByPackage (inSET) {
      try {
        const params = {
          shopObjectId: this.shopObjectId,
          startAt: moment(this.date.start).format('YYYY-MM-DD'),
          endAt: moment(this.date.end).format('YYYY-MM-DD'),
          packageObjectId: this.packageId,
          inSET
        }

        const res = await axios.get(
          '/api/v3.0/package/mostorder/statistics',
          { params }
        )

        const raw = Array.isArray(res.data.data) ? res.data.data : []

        const mapped = raw.map(r => ({
          key: r._id,
          pluName: r.pluName,
          categoryName: r.categoryName || '-',
          totalQty: Number(r.quantity) || 0,
          totalAmount: Number(r.netAmount) || 0
        }))
      const top10 = mapped.slice(0, 10)
        if (inSET) {
          this.buffetMostOrders = top10
        } else {
          this.extraMostOrders = top10
        }
      } catch (err) {
        console.error('fetchMostOrderByPackage error', err)
        if (inSET) {
          this.buffetMostOrders = []
        } else {
          this.extraMostOrders = []
        }
      }
    },

    formatMoney (n) {
      const num = Number(n) || 0
      return num.toLocaleString('th-TH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    formatDateTime (iso) {
      if (!iso) return '-'
      const d = new Date(iso)
      return d.toLocaleString('th-TH', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    hexToRgba (hex, alpha) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c & 255}, ${alpha})`
      }
      return hex
    },

    getBuffetChartColor (index) {
      const colors =
        this.buffetTopChart.datasets[0].backgroundColor || ['#ebedef']
      return colors[index % colors.length]
    },

    getBuffetBackgroundColor (index) {
      const hexColor = this.getBuffetChartColor(index)
      return this.hexToRgba(hexColor, 0.03)
    },

    getExtraChartColor (index) {
      const colors =
        this.extraTopChart.datasets[0].backgroundColor || ['#ebedef']
      return colors[index % colors.length]
    },

    getExtraBackgroundColor (index) {
      const hexColor = this.getExtraChartColor(index)
      return this.hexToRgba(hexColor, 0.03)
    },

    toggleHistoryDetails (item) {
      const id = item.id

      if (this.historyDetails[0] === id) {
        this.historyDetails = []
        return
      }

      this.historyDetails = [id]

      const hasItems =
        (item.buffetItems && item.buffetItems.length) ||
        (item.extraItems && item.extraItems.length)

      if (!hasItems) {
        this.fetchOrderItemsByReceipt(item)
      }
    },
    getOrderShopSetting(){
      const shopObjectId = `${localStorage.getItem('shopObjectId')}`
      let params = {
          shopObjectId: shopObjectId,
      }
      const headers = {
          shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      pos({
          url: "/api/v3.0/shop/ordershopsetting",
          params: params,
          headers: headers,
          method: "get",
      }).then((res) => {
          if(res.status ==200){
              let isOrderBuffetEnabled  = res.data.data.isOrderBuffetEnabled
              if(isOrderBuffetEnabled!== undefined && isOrderBuffetEnabled !== null && isOrderBuffetEnabled!==''){
                  this.isOrderBuffetEnabled = isOrderBuffetEnabled
              }else{
                  this.isOrderBuffetEnabled = false
              }
          }else{
              this.isOrderBuffetEnabled = false
          }
          
      }).catch((error) => {
              console.log(error);
      });
    },
  }
}
</script>

<style scoped>
.metric-card {
  position: relative;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  display: flex;
}

.metric-card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* เส้นสีด้านซ้าย */
.metric-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  width: 4px;
  border-radius: 999px;
}

/* สีของแต่ละการ์ด */
.metric-card--bills::before {
  background: #20c997;
}

.metric-card--customers::before {
  background: #20c997;
}

.metric-title {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.metric-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #20c997;
  line-height: 1.2;
}

.metric-sub {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 2px;
}

.metric-icon {
  color: #20c997;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ตาราง price stats ให้ row สูงเท่ากัน */
::v-deep(.price-stats-table tbody tr) {
  height: 40px;
}

/* TOP list */
.top-list {
  max-height: 270px;
  overflow-y: auto;
}

/* list แต่ละอันให้สูงเท่ากัน + มี accent สี */
::v-deep(.top-list-item) {
  border-radius: 8px;
  margin: 0.35rem 0;
  border-left: 8px solid var(--accent-color, #20c997);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  padding: 6px 10px;
  background-color: rgba(0, 0, 0, 0.01);
  min-height: 64px;
  display: flex;
  align-items: center;
}

::v-deep(.top-list-item .row) {
  width: 100%;
}
</style>
